import { axiosInstance } from './index';
import { UserCacheDataType } from '../../types/userCacheDataType';

export const userCacheDataService = {
    saveOxData(data: UserCacheDataType) {
        axiosInstance.post(`User/OxData`, data);
    },
    async getOxData(emailId: string) {
        const { data: responseData } = await axiosInstance.get(`User/GetOxData/${emailId}`);
        return responseData as any;
    },
    async deleteOxData(emailId: string) {
        const { data: responseData } = await axiosInstance.delete(`User/DeleteOxData/${emailId}`);
        return responseData as any;
    },
    async updateOxData(data: UserCacheDataType) {
        const { data: responseData } = await axiosInstance.put(`User/UpdateOxData`, data);
        return responseData as any;
    },


};
